import clsx from 'clsx';
import { useFormikContext } from 'formik';
import { useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import LabelRequired from '../../../../../../../../../../component/LabelRequired';
import TextField from '../../../../../../../../../../component/TextField';
import ICD10 from '../../../../../../../../../../phan-he-kham-benh/components/ICD10';
import { IDanhSachDanhMuc } from '../../../../../../../../../../phan-he-tiep-nhan-thanh-toan/models/TiepDonModel';
import { KEY_DS_DANH_MUC_TIEP_DON } from '../../../../../../../../../../utils/Constant';
import { getIndexedDBItem } from '../../../../../../../../../../utils/IndexedDB';

type Props = {
	rowClassName?: string;
	labelAlign?: 'top' | 'left';
	inputClassName?: string;
	isView?: boolean;
};

const BenhKemTheo = ({ rowClassName, labelAlign, inputClassName, isView = false }: Props) => {
	const { values, setValues } = useFormikContext<any>();

	const [listComorbidity, setListComorbidity] = useState<any[]>([]);
	const [openICD10Dialog, setOpenICD10Dialog] = useState(false);
	const [openSelectICD10Dialog, setOpenSelectICD10Dialog] = useState(false);
	const [listICD10, setListICD10] = useState<any[]>([]);

	useEffect(() => {
		getDanhMuc();
	}, []);

	const getDanhMuc = async () => {
		const danhMuc: IDanhSachDanhMuc = await getIndexedDBItem(KEY_DS_DANH_MUC_TIEP_DON);
		setListICD10(danhMuc.listICD10);
	};

	const SelectButton = () => {
		return (
			<Button
				className="link-info bg-white text-decoration-underline spaces pb-0 pr-0"
				onClick={() => {
					setOpenSelectICD10Dialog(true);
				}}
				disabled={isView}
			>
				Chọn bệnh kèm theo
			</Button>
		);
	};

	return (
		<Row className={clsx('spaces pt-10 pl-6 mb-10', rowClassName)}>
			{labelAlign === 'top' ? (
				<>
					<Col sm={2} className="spaces pl-4">
						<LabelRequired label="Bệnh kèm theo" className="spaces pl-8" />
					</Col>
					<Col sm={10} className="d-flex flex-end">
						<SelectButton />
					</Col>
				</>
			) : (
				<>
					<Col xs="12" className="d-flex flex-end">
						<SelectButton />
					</Col>
					<Col sm={2} className="spaces pl-4">
						<LabelRequired label="Bệnh kèm theo" />
					</Col>
				</>
			)}

			<Col sm={labelAlign === 'top' ? 12 : 10} className={inputClassName}>
				<TextField
					name="comorbidity"
					value={values?.comorbidity || ''}
					className="resize-none"
					labelClassName="ms-0 min-w-150px"
					as="textarea"
					rows={3}
					disabled={isView}
				/>
			</Col>

			<ICD10
				shouldOpenModalICD10={openICD10Dialog}
				setShouldOpenModalICD10={setOpenICD10Dialog}
				shouldOpenModalSelectICD10={openSelectICD10Dialog}
				setShouldOpenModalSelectICD10={setOpenSelectICD10Dialog}
				listICD10={listICD10}
				listComorbidity={listComorbidity}
				setListComorbidity={setListComorbidity}
				selectionModeICD10="radio"
				data={values}
				onChange={value => {
					setValues({
						...values,
						...value,
					});
				}}
			/>
		</Row>
	);
};

export default BenhKemTheo;
